import { createEffect, createSignal, For, Show } from "solid-js";
import { cn } from "@/libs/cn";
import { Button } from "@/components/shadcn/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "@/components/shadcn/dropdown-menu";
import {
  Checkbox,
  CheckboxControl,
} from "@/components/shadcn/checkbox";
import { Icon } from "@iconify-icon/solid";
import { Badge } from "@/components/ui/Badge";

export const ListAction = (props) => {
  const [checked, setChecked] = createSignal(false);

  const onChange = (checked) => {
    props.onCheck(checked);
  }

  createEffect(() => {
    props.checkedItems;
    setChecked(props.checkedItems.length > 0 && props.checkedItems.length === props.items);
  });

  createEffect(() => {
    props.items;
    setChecked(props.checkedItems.length > 0 && props.checkedItems.length === props.items);
  });

  return (
    <Show when={props.actions.length > 0}>
      <div class="flex items-center gap-2">
        <Show when={props.mode !== 'table'}>
          <Checkbox class="flex items-center" checked={checked()} onChange={(checked) => onChange(checked)}>
            <CheckboxControl class="border-gray-400 shadow-none" />
          </Checkbox>
        </Show>
        <Show when={props.checkedItems.length > 0}>
          <DropdownMenu>
            <DropdownMenuTrigger as={(innerProps) => <Button variant={"outline"}
              class={cn(
                "justify-start text-left font-normal px-3 py-0 my-0",
                "text-muted-foreground",
                "py-0 my-0 h-auto",
                "relative",
              )} {...innerProps} />}>
              <span class="h-9 flex items-center gap-1">
                <Icon icon="eva:menu-fill" class="h-4 w-4 hidden" />
                Actions
              </span>
              <Badge class="absolute top-[-8px] right-[-8px]" shape="rounded" variant="success">{props.checkedItems.length}</Badge>
            </DropdownMenuTrigger>
            <DropdownMenuContent>
              <For each={props.actions}>{(option, i) =>
                <DropdownMenuItem class="text-muted-foreground" onClick={() => props.onAction(option)}>
                  <Icon icon={option.icon} />
                  <span class="text-xs">{option.text}</span>
                </DropdownMenuItem>
              }</For>
            </DropdownMenuContent>
          </DropdownMenu>
        </Show>
      </div>
    </Show>
  );
}
